import * as React from 'react';

import { ReplayOutlined } from '@mui/icons-material';
import { Button, Card, CardContent, Fade, Typography } from '@mui/material';

const MuxPlayerError: React.FC = () => {
  return (
    <Card className="py-8 px-6 bg-paper w-full h-full" sx={{ boxShadow: 'none' }}>
      <Fade in>
        <CardContent className="h-full flex flex-col justify-center mx-auto text-center max-w-[600px] gap-y-4 md:gap-y-6">
          <img src="/assets/images/checkout/cancel.svg" alt="cancel" className="mx-auto" />
          <Typography variant="h4" component="h3" className="text-error-light mb-2 md:mb-6">
            C'è stato un problema nel riprodurre la lezione selezionata
          </Typography>

          <Button
            className="mx-auto"
            color="primary"
            variant="contained"
            startIcon={<ReplayOutlined className="size-5" />}
            onClick={(e) => {
              e.stopPropagation();
              window.location.reload();
            }}
          >
            <Typography variant="button-m" component="p">
              Ricarica
            </Typography>
          </Button>
        </CardContent>
      </Fade>
    </Card>
  );
};

export { MuxPlayerError };
